import moment from 'moment';
import { ExportTableApi } from '../../api';
import { saveAs } from 'file-saver';
import { effectifValue, getH2sDataColor } from './tableHelper';

interface IndusFiltered {
  CommuneCollectionPool: string;
  Commune: string;
  Section: string;
  Establishment: string;
  MainActivity: string;
  DomesticAssimilated: string;
  EmployeeCount: string;
  NafRank: string;
  RsdeRank: string;
  GlobalRank: string;
  CategColor: string;
}

interface CollectionPoolFiltered {
  Commune: string;
  Label: string;
  AvalPoint: string;
  ActiveSurface: string;
  Color: string;
}

interface HydroFiltered {
  CommuneCollectionPool: string;
  InterventionType: string;
  InterventionNature: string;
  Synthesis: string;
  Effective: string;
}

interface H2sExportDetail {
  Date: string;
  BoonAndLister: string;
  CanaSojourn: string;
  PrSojourn: string;
  SelfCleaning: string;
}

interface RainyEventFiltered {
  Commune: string;
  Name: string;
  Type: string;
  Volume: string;
  Pluie: string;
  CategColor: string;
}

interface CollectionPoolSummaryExport {
  CollectionPoolName: string;
  CollectionPoolAvalPoint: string;
  PRMRColor: string;
  DOTPColor: string;
  ECPColor: string;
  H2SColor: string;
  PluieColor: string;
  MilieuColor: string;
  HydroColor: string;
  IndusColor: string;
}

interface MainInstallFiltered {
  ContractId: string;
  ContractCode: string;
  ContractLabel: string;
  Commune: string;
  Name: string;
  Type: string;
  Criticity: string;
  DailyCharge: number;
  DailyChargeCateg: number;
  CategColor: string;
  MainInstallCode: string;
  StatusCode: string;
  Value: string;
}

export const hydroDataFormated = (pData: any[]) => {
  let dataFormated: any[] = [];
  pData.forEach((data) => {
    const hydroCommune = window.sessionStorage.getItem('hydro_commune');
    const hydroType = window.sessionStorage.getItem('hydro_type');
    const hydroNature = window.sessionStorage.getItem('hydro_nature');

    const communeBc = hydroCommune ? JSON.parse(hydroCommune).name : 'Toutes les communes';
    const type = hydroType ? JSON.parse(hydroType).name : 'Tous les types';
    const nature = hydroNature ? JSON.parse(hydroNature).name : 'Toutes les natures';

    dataFormated.push({
      synthese: data.label,
      effectif: data.effectif,
      communeBc: communeBc !== '' ? communeBc : 'Toutes les communes',
      type: type !== '' ? type : 'Tous les types',
      nature: nature !== '' ? nature : 'Toutes les natures',
    });
  });
  return dataFormated;
};

export const getPropertyValueContainingString = (obj: any, searchString: string) => {
  const propertyName = Object.keys(obj).find(key => key.includes(searchString));
  return propertyName ? obj[propertyName] : null;
}

export const strNoAccent = (chain: string) => {
  // this doesn't work anymore
  // return chain.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return chain.split("'").join(' ');
}

// prepare body for request hence type of module
export const prepareDataToSend = (pData: any[], pType: string) => {
  let arrayToSend: any = [];
  pData.forEach((line) => {
    if (pType === 'do') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        categColor: line.Color === null ? 'Non disponible' : line.Color,
      });
    } else if (pType === 'pr') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        categColor: line.Color === null ? 'Non disponible' : line.Color,
        criticity: line.CriticityCode,
      });
    } else if (pType === 'h2s') {
      const h2sDataColor = getH2sDataColor();
      const h2sDataValue = getPropertyValueContainingString(line, 'Value');
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        categColor: h2sDataColor === null ? 'Non disponible' : line[h2sDataColor],
        value: String(h2sDataValue === null ? 'Non disponible' : h2sDataValue),
      });
    } else if (pType === 'ecp') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        label: line.collectionPoolLabel,
        avalPoint: line.Code,
        color: line.Color === null ? 'NOIR' : line.Color,
      });
    } else if (pType === 'indus') {
      arrayToSend.push({
        commune: line.City === null ? 'Non disponible' : line.City,
        communeCollectionPool: line.communeBc,
        establishment: line.Name === null ? 'Non disponible' : line.Name,
        mainActivity: line.ActivityLabel,
        domesticAssimilated:
          line.WarsmannNote === null
            ? 'Non disponible'
            : line.WarsmannNote === 1 ? 'Oui' : 'Non',
        section: line.SectionLabel,
        globalRank: String(line.Global_Note),
        employeeCount: effectifValue(line.SalariedWorkforceSlice),
        nafRank:
          line.NAF_Note === null ? 'Non disponible' : String(line.NAF_Note),
        rsdeRank:
          line.RSDE_Note === null ? 'Non disponible' : String(line.RSDE_Note),
      });
    } else if (pType === 'hydro') {
      arrayToSend.push({
        communeCollectionPool: line.communeBc,
        interventionType: line.type,
        interventionNature: line.nature,
        synthesis: line.synthese,
        effective: String(line.effectif),
      });
    } else if (pType === 'pluie') {
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
        volume: line.Volume === null ? 'Non disponible' : String(line.Volume),
        pluie: line.Mesure === null ? 'Non disponible' : String(line.Mesure),
        categColor: line.Color === null ? 'Non disponible' : line.Color,
      });
    } else if (pType === 'h2s-detail') {
      arrayToSend.push({
        date: line.date === null ? 'Non disponible' : line.date,
        boonAndLister:
          line.boonAndLister === null ? 'Non disponible' : String(line.boonAndLister),
        canaSojourn:
          line.canaSojourn === null ? 'Non disponible' : String(line.canaSojourn),
        prSojourn: line.prSojourn === null ? 'Non disponible' : String(line.prSojourn),
        selfCleaning: line.selfCleaning === null ? 'Non disponible' : String(line.selfCleaning),
      });
    } else if (pType === 'CollectionPool') {
      arrayToSend.push({
        collectionPoolName:
          line.collectionPoolName === null
            ? 'Non disponible'
            : strNoAccent(line.collectionPoolName).replace(/\(/g, '').replace(/\)/g, '').replace(/\d/g, ''),
        collectionPoolAvalPoint:
          line.collectionPoolAvalPoint === null
            ? 'Non disponible'
            : strNoAccent(line.collectionPoolAvalPoint),
        dotpColor:
          line.dotpColor === null ? 'Non disponible' : String(line.dotpColor),
        prmrColor:
          line.prmrColor === null ? 'Non disponible' : String(line.prmrColor),
        ecpColor:
          line.ecpColor === null ? 'Non disponible' : String(line.ecpColor),
        h2SColor:
          line.h2SColor === null ? 'Non disponible' : String(line.h2SColor),
        indusColor:
          line.indusColor === null
            ? 'Non disponible'
            : String(line.indusColor),
        hydroColor:
          line.hydroColor === null
            ? 'Non disponible'
            : String(line.hydroColor),
        milieuColor:
          line.milieuColor === null
            ? 'Non disponible'
            : String(line.milieuColor),
        pluieColor:
          line.pluieColor === null
            ? 'Non disponible'
            : String(line.pluieColor),
      });
    } else if (pType === 'admin-users') {
      arrayToSend.push({
        id: line.id === null ? 'Non disponible' : line.id,
        username: line.login === null ? 'Non disponible' : line.login,
        firstName:
          line.firstName === null ? 'Non disponible' : String(line.firstName),
        lastName:
          line.lastName === null ? 'Non disponible' : String(line.lastName),
        role: line.role === null ? 'Non disponible' : String(line.role),
        email: line.email === null ? 'Non disponible' : String(line.email),
        enabled: line.enabled,
        emailVerified:
          line.emailVerified,
      });
    } else {
      // milieu
      arrayToSend.push({
        commune: line.Commune === null ? 'Non disponible' : line.Commune,
        name: strNoAccent(line.Description),
        type: line.ModelCode,
      });
    }
  });
  return arrayToSend;
};

export const defineTypeOfCsvName = (pType: string) => {
  return pType === 'h2s' ? window.sessionStorage.getItem('h2s_indicator') || 'h2s' : pType;
};

const generateIndusCsv = (exportList: IndusFiltered[]): string => {
  if (!Array.isArray(exportList)) {
    throw new Error('exportList is not an array');
  }

  const lines: string[] = [];

  lines.push(
    'Commune/Bassin de collecte;Commune;Section;Etablissement;Activité principale;' +
    'Note NAF;Note RSDE; Note globale;Assimilé domestique;Nombre de salariés'
  );

  exportList.forEach(record => {
    lines.push(
      `${record.CommuneCollectionPool ?? ''};` +
      `${record.Commune ?? ''};` +
      `${record.Section?.replace(/;/g, ',') ?? ''};` +
      `${record.Establishment?.replace(/;/g, ',') ?? ''};` +
      `${record.MainActivity?.replace(/;/g, ',') ?? ''};` +
      `${record.NafRank ?? ''};` +
      `${record.RsdeRank ?? ''};` +
      `${record.GlobalRank ?? ''};` +
      `${record.DomesticAssimilated ?? ''};` +
      `${record.EmployeeCount ?? ''};` +
      `${record.CategColor ?? ''}`
    );
  });

  return lines.join('\n');
};

const mapToIndusFiltered = (item: any) => ({
  CommuneCollectionPool: item.communeCollectionPool ?? '', 
  Commune: item.commune ?? '',
  Section: item.section ?? '',
  Establishment: item.establishment ?? '',
  MainActivity: item.mainActivity ?? '',
  DomesticAssimilated: item.domesticAssimilated ?? '',
  EmployeeCount: item.employeeCount ?? '',
  NafRank: item.nafRank ?? '',
  RsdeRank: item.rsdeRank ?? '',
  GlobalRank: item.globalRank ?? '',
  CategColor: item.categColor ?? ''
});

const mapToMainInstallFiltered = (item: any): MainInstallFiltered => ({
  ContractId: item.contractId ?? '',
  ContractCode: item.contractCode ?? '',
  ContractLabel: item.contractLabel ?? '',
  Commune: item.commune ?? '',
  Name: item.name ?? '',
  Type: item.type ?? '',
  Criticity: item.criticity ?? '',
  DailyCharge: item.dailyCharge ?? 0,
  DailyChargeCateg: item.dailyChargeCateg ?? 0,
  CategColor: item.categColor ?? '',
  MainInstallCode: item.mainInstallCode ?? '',
  StatusCode: item.statusCode ?? '',
  Value: item.value ?? ''
});

const generateMainInstallCsv = (
  exportList: MainInstallFiltered[]
): string => {
  if (!Array.isArray(exportList) || exportList.length === 0) {
    return '';
  }

  const lines: string[] = [];
  const firstType = exportList[0].Type;

  if (firstType === 'MDI_PR') {
    lines.push('Commune;Nom;Type;Criticité;Catégorie;Valeur');

    exportList.forEach(record => {
      lines.push(
        `${record.Commune ?? ''};` +
        `${record.Name ?? ''};` +
        `${record.Type ?? ''};` +
        `${record.Criticity ?? ''};` +
        `${record.CategColor ?? ''};` +
        `${record.Value ?? ''}`
      );
    });
  } else {
    lines.push('Commune;Nom;Type;Catégorie');

    exportList.forEach(record => {
      lines.push(
        `${record.Commune ?? ''};` +
        `${record.Name ?? ''};` +
        `${record.Type ?? ''};` +
        `${record.CategColor ?? ''}`
      );
    });
  }

  return lines.join('\n');
};

const generateRainyEventCsv = (exportList: RainyEventFiltered[]): string => {
  if (!Array.isArray(exportList)) {
    throw new Error('exportList is not an array');
  }

  const lines: string[] = [];

  lines.push('Commune;Nom;Type;Volume;Pluie;Couleur');

  exportList.forEach(record => {
    lines.push(
      `${record.Commune ?? ''};` +
      `${record.Name ?? ''};` +
      `${record.Type ?? ''};` +
      `${record.Volume ?? ''};` +
      `${record.Pluie ?? ''};` +
      `${record.CategColor ?? ''}`
    );
  });

  return lines.join('\n');
};

const mapToRainyEventFiltered = (item: any): RainyEventFiltered => ({
  Commune: item.commune ?? '',
  Name: item.name ?? '',
  Type: item.type ?? '',
  Volume: item.volume ?? '',
  Pluie: item.pluie ?? '',
  CategColor: item.categColor ?? ''
});

const generateCollectionPoolSummaryCsv = (
  exportList: CollectionPoolSummaryExport[]
): string => {
  if (!Array.isArray(exportList) || exportList.length === 0) {
    return '';
  }

  const lines: string[] = [];

  lines.push(
    'Nom;Point limite aval;PR MR;DO TP;ECP;H2S;Pluie;Milieu;Hydro;Indus'
  );

  exportList.forEach(record => {
    lines.push(
      `${record.CollectionPoolName ?? ''};` +
      `${record.CollectionPoolAvalPoint ?? ''};` +
      `${record.PRMRColor ?? ''};` +
      `${record.DOTPColor ?? ''};` +
      `${record.ECPColor ?? ''};` +
      `${record.H2SColor ?? ''};` +
      `${record.PluieColor ?? ''};` +
      `${record.MilieuColor ?? ''};` +
      `${record.HydroColor ?? ''};` +
      `${record.IndusColor ?? ''}`
    );
  });

  return lines.join('\n');
};

const mapToCollectionPoolSummaryExport = (
  item: any
): CollectionPoolSummaryExport => ({
  CollectionPoolName: item.collectionPoolName ?? '',
  CollectionPoolAvalPoint: item.collectionPoolAvalPoint ?? '',
  PRMRColor: item.prmrColor ?? '',
  DOTPColor: item.dotpColor ?? '',
  ECPColor: item.ecpColor ?? '',
  H2SColor: item.h2sColor ?? '',
  PluieColor: item.pluieColor ?? '',
  MilieuColor: item.milieuColor ?? '',
  HydroColor: item.hydroColor ?? '',
  IndusColor: item.indusColor ?? ''
});


const generateEcpCsv = (exportList: CollectionPoolFiltered[]): string => {
  if (!Array.isArray(exportList)) {
    throw new Error('exportList is not an array');
  }
  const lines: string[] = [];

  lines.push('Commune;Bassin de collecte;Point Aval;Surface Active;Catégorie');

  exportList.forEach(record => {
    lines.push(
      `${record.Commune ?? ''};` +
      `${record.Label ?? ''};` +
      `${record.AvalPoint ?? ''};` +
      `${record.ActiveSurface ?? ''};` +
      `${record.Color ?? ''}`
    );
  });

  return lines.join('\n');
};

const mapToEcpFiltered = (item: any): CollectionPoolFiltered => ({
  Commune: item.commune ?? '',
  Label: item.label ?? '',
  AvalPoint: item.avalPoint ?? '',
  ActiveSurface: item.activeSurface ?? '',
  Color: item.color ?? ''
});


const generateHydroCsv = (exportList: HydroFiltered[]): string => {
  if (!Array.isArray(exportList)) {
    throw new Error('exportList is not an array');
  }

  const lines: string[] = [];

  lines.push(
    "Commune/Bassin de collecte;Type d'interventions;Nature d'intervention;Synthèse;Effectif"
  );

  exportList.forEach(record => {
    lines.push(
      `${record.CommuneCollectionPool ?? ''};` +
      `${record.InterventionType ?? ''};` +
      `${record.InterventionNature ?? ''};` +
      `${record.Synthesis ?? ''};` +
      `${record.Effective ?? ''}`
    );
  });

  return lines.join('\n');
};
const mapToHydroFiltered = (item: any): HydroFiltered => ({
  CommuneCollectionPool: item.communeCollectionPool ?? '',
  InterventionType: item.interventionType ?? '',
  InterventionNature: item.interventionNature ?? '',
  Synthesis: item.synthesis ?? '',
  Effective: item.effective ?? ''
});


const mapToH2sExportDetail = (item: any): H2sExportDetail => ({
  Date: item.date ?? '',
  BoonAndLister: item.boonAndLister ?? '',
  CanaSojourn: item.canaSojourn ?? '',
  PrSojourn: item.prSojourn ?? '',
  SelfCleaning: item.selfCleaning ?? ''
});


const generateH2sCsv = (exportList: H2sExportDetail[]): string => {
  if (!Array.isArray(exportList) || exportList.length === 0) {
    return '';
  }

  const lines: string[] = [];

  lines.push(
    "Date;Boon et lister;Temps de séjour CR;Temps de séjour PR;Vitesse d'autocurage"
  );

  exportList.forEach(record => {
    lines.push(
      `${record.Date ?? ''};` +
      `${record.BoonAndLister ?? ''};` +
      `${record.CanaSojourn ?? ''};` +
      `${record.PrSojourn ?? ''};` +
      `${record.SelfCleaning ?? ''}`
    );
  });

  return lines.join('\n');
};


// fetch to get csv
export const requestToGetCsv = async (
  pBody: any,
  pType: string,
  pContractLabel: string,
  pExtendeUrl: string
) => {
  let response;
  if (pType === 'indus' || pType === 'hydro' || pType === 'ecp') {

    try {

      const filename ='export-' + defineTypeOfCsvName(pType) +
        '-' + pContractLabel +
        '-' + moment().utc().format('YYYY-MM-DD') + '.csv';

      if (pType === 'indus') {
        const parsed = JSON.parse(pBody);
        const mapped = parsed.map(mapToIndusFiltered);
        createBlob('\uFEFF' + generateIndusCsv(mapped), filename);
        return;
      }
      
      if (pType === 'ecp') {
        const parsed = JSON.parse(pBody);
        const mapped = parsed.map(mapToEcpFiltered);
        createBlob('\uFEFF' + generateEcpCsv(mapped), filename);
        return;
      }
      
      if (pType === 'hydro') {
        const parsed = JSON.parse(pBody);
        const mapped = parsed.map(mapToHydroFiltered);
        createBlob('\uFEFF' + generateHydroCsv(mapped), filename);
        return;
      }

      return; 
    } catch (e) {
      console.error('Failed to generate CSV', e);
    }
   
  } else if (pType === 'pluie') {
    try {
      const parsedBody = typeof pBody === 'string' ? JSON.parse(pBody) : pBody;

    if (!Array.isArray(parsedBody)) {
      return;
    }

    const mapped = parsedBody.map(mapToRainyEventFiltered);

    const filename ='export-' + defineTypeOfCsvName(pType) +
      '-' + pContractLabel +
      '-' + moment().utc().format('YYYY-MM-DD') + '.csv';

    createBlob('\uFEFF' + generateRainyEventCsv(mapped), filename);
    return;
    } catch (e) {
      console.error('Failed to request', e);
    }
  } else if (pType === 'CollectionPool') {
    try {
      const parsedBody = typeof pBody === 'string' ? JSON.parse(pBody) : pBody;

    if (!Array.isArray(parsedBody) || parsedBody.length === 0) {
      return;
    }

    const mapped = parsedBody.map(mapToCollectionPoolSummaryExport);

    const filename =
      'export-recap-bassin-de-collecte-' +
      moment().utc().format('YYYY-MM-DD') +
      '.csv';

    createBlob('\uFEFF' + generateCollectionPoolSummaryCsv(mapped), filename);
    return;

    } catch (e) {
      console.error('Failed to request', e);
    }
  } else if (pType === 'h2s-detail') {
    try {
      const parsedBody = typeof pBody === 'string' ? JSON.parse(pBody) : pBody;

    if (!Array.isArray(parsedBody) || parsedBody.length === 0) {
      return;
    }

    const mapped = parsedBody.map(mapToH2sExportDetail);

    const filename = 'export-h2s-' + moment().utc().format('YYYY-MM-DD') + '.csv';

    createBlob('\uFEFF' + generateH2sCsv(mapped), filename);
    return;
    } catch (e) {
      console.error('Failed to generate H2S CSV', e);
    }
  } else {
    try {
      const parsedBody = typeof pBody === 'string' ? JSON.parse(pBody) : pBody;

      if (!Array.isArray(parsedBody) || parsedBody.length === 0) {
        return;
      }
  
      const mapped = parsedBody.map(mapToMainInstallFiltered);
  
      const filename =
        'export-liste-' +
        mapped[0].Type +
        '-' +
        moment().utc().format('YYYY-MM-DD') +
        '.csv';
  
      createBlob('\uFEFF' + generateMainInstallCsv(mapped), filename);
      return;
    } catch (e) {
      console.error('Failed to generate Pluie CSV', e);
    }
  }

  const filename =
    'export-' +
    defineTypeOfCsvName(pType) +
    '-' +
    (pType !== 'admin-users' ? pContractLabel + '-' : '') +
    moment().utc().format('YYYY-MM-DD') +
    '.csv';
  createBlob(response.data, filename);
};

// specify end point
export const defineExtendedUrl = (pType: string) => {
  let extendedUrl = '';
  if (pType === 'ecp') {
    extendedUrl = '/ecp';
  } else if (pType === 'indus') {
    extendedUrl = '/indus';
  } else if (pType === 'hydro') {
    extendedUrl = '/hydro';
  } else if (pType === 'milieu') {
    extendedUrl = '/milieu';
  }
  return extendedUrl;
};

// create a blob for csv file
export const createBlob = (pData: any, pFilename: string) => {
  const blob = new Blob(['\ufeff' + pData], {
    type: 'data:text/csv;charset=utf-8,',
  });
  saveAs(blob, pFilename);
};
